import {FIELD_ORDER_UI_SCHEMA_KEY, ShapeUISchemaNestedShapeValues} from '../../StepConfigEditorTypes';
import {createLegendStyleSection} from './ChartSchemaHelpers';

/**
 * Heatmap configuration sections for the Configure tab
 */
export const HEATMAP_CONFIG_SECTIONS = {
  [FIELD_ORDER_UI_SCHEMA_KEY]: ['configSection'],
  configSection: {
    [FIELD_ORDER_UI_SCHEMA_KEY]: ['rows', 'columns', 'metric', 'gradientDirection'],
    rows: {
      displayName: 'Rows',
      configShapePath: ['chartConfig', 'parameters', 'yAxisColumnName'],
    },
    columns: {
      displayName: 'Columns',
      configShapePath: ['chartConfig', 'parameters', 'xAxisColumnName'],
    },
    metric: {
      displayName: 'Metric',
      configShapePath: ['chartConfig', 'parameters', 'metricColumnName'],
    },
    gradientDirection: {
      displayName: 'Gradient direction',
      configShapePath: ['chartConfig', 'parameters', 'gradientDirection'],
      fieldSettings: {
        displayNames: {
          ASCENDING_METRIC_VALUES: 'Ascending',
          DESCENDING_METRIC_VALUES: 'Descending',
        },
      },
    },
  },
} as const satisfies ShapeUISchemaNestedShapeValues;

export const HEATMAP_STYLE_SECTIONS = {
  [FIELD_ORDER_UI_SCHEMA_KEY]: ['legendSection'],
  legendSection: createLegendStyleSection({disableFn: false}),
} as const satisfies ShapeUISchemaNestedShapeValues;
